export default __webpack_public_path__ + "static/media/empty.cb91ed3c.png";